/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Main_NavigationInputs */

const sv_main_navigation = /** @type {(inputs: Main_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huvudnavigation`)
};

const en_main_navigation = /** @type {(inputs: Main_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Main_NavigationInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const main_navigation = /** @type {((inputs?: Main_NavigationInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Main_NavigationInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_main_navigation(inputs)
	return en_main_navigation(inputs)
});